import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Info from './Info';
import LazyBg from '../../../UI/LazyImage/LazyBg';
import './Grid.css';

const Grid = ({ property, filters }) => {
    const { name, city, state, state_long_name, thumbnail, slug } = property;
    const imgUrl = thumbnail
        ? `${process.env.RAZZLE_ASSET_URL}${thumbnail}`
        : '/thumbnail';

    return (
        <div className="property-wrapper">
            <Link to={`/office/${slug}`} className="property-card">
                <div className="grid-image">
                    <div className="image grid-image-container">
                        <LazyBg src={imgUrl} className="lazy-image" />
                        <div className="location-container">
                            <div className="location">{name}</div>
                            <div className="location-city">{`${city}, ${
                                state_long_name ? state_long_name : state.substring(0, 2)
                            }`}</div>
                        </div>
                    </div>
                </div>
            </Link>
            <Info property={property} filters={filters} />
            <hr className="grid-hr" />
        </div>
    );
};

Grid.propTypes = {
    property: PropTypes.shape({
        name: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        state: PropTypes.string,
        state_long_name: PropTypes.string,
        slug: PropTypes.string.isRequired,
        thumbnail: PropTypes.string,
    }).isRequired,
    filters: PropTypes.object,
};

export default Grid;
